/* eslint formatjs/no-literal-string-in-jsx: "off" -- will be deleted with the completion of https://carrotfertility.atlassian.net/browse/LG-901 */

import React, { useContext, useState } from "react"
import L10n from "lib/carrot-l10n"
import WizardWrapper from "components/views/atoms/forms/WizardWrapper"
import RequestCardHeader from "components/views/requestcard/RequestCardHeader"
import { HR, Spacer } from "components/views/atoms/Atoms"
import { useDidMount } from "utils/Hooks"
import { sleep } from "utils/Helpers"
import RequestCardWizardHeader from "components/views/requestcard/RequestCardWizardHeader"
// eslint-disable-next-line import/no-restricted-paths
import ErrorMessageMarkdown from "../login/ErrorMessageMarkdown"
import { Body } from "../atoms/Bodies"
// eslint-disable-next-line import/no-restricted-paths
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyWithRightSidebarLayout } from "../atoms/layouts/BodyWithRightSidebarLayout"
import { TextLink } from "../atoms/links/TextLink"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { HttpErrors } from "utils/HttpErrors"
import CarrotClient from "carrot-api"
import Settings from "utils/CarrotConfig"
import { useForm } from "react-hook-form"
import { RequestCardContext } from "components/containers/requestcard/RequestCardContainer"
import { useHistory } from "react-router-dom"
import { PhoneCodes } from "../../../content/PhoneCodes"
import EmployeeOnlySpaceContainer from "../../employee-only-containers/EmployeeOnlySpaceContainer"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
// @ts-expect-error TS7009
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

type VerificationFormData = {
  verificationCode: string
}

const DefaultVerifyPhoneNumberState = {
  formNotComplete: false,
  isInError: false,
  sending: false,
  isResendLinkVisible: false
}

// @ts-expect-error TS7006
const VerifyPhoneNumber = (props) => {
  const { phoneNumber, countryCode } = useContext(RequestCardContext)
  const {
    handleSubmit,
    register,
    formState: { errors },
    formState,
    setError,
    clearErrors
  } = useForm<VerificationFormData>()
  const [state, setState] = useState(DefaultVerifyPhoneNumberState)
  const history = useHistory()
  useDidMount(() => {
    enableResend()
  })

  const enableResend = async () => {
    await sleep(4000)
    setState({ ...state, isResendLinkVisible: true })
  }

  const handleResendClick = async () => {
    resendVerification()
    setState({ ...state, isResendLinkVisible: false })
    enableResend()
  }

  const resendVerification = async () => {
    const phoneCountryCode = PhoneCodes[countryCode]
    const phoneNumberWithCountryCode = `${phoneCountryCode}${phoneNumber}`
    try {
      await client.startPhoneVerification(phoneNumberWithCountryCode, countryCode)
    } catch (e) {
      setState({ ...state, isInError: true })
    }

    return true
  }

  const onSubmit = handleSubmit(async (formData) => {
    clearErrors()
    const phoneCountryCode = PhoneCodes[countryCode]
    const phoneNumberWithCountryCode = `${phoneCountryCode}${phoneNumber}`
    try {
      setState({
        ...state,
        formNotComplete: false,
        isInError: false,
        sending: true
      })
      await client.verifyPhoneNumber(phoneNumberWithCountryCode, formData.verificationCode, countryCode)
      history.push("/request-card/user-agreement")
    } catch (e) {
      if (e.name === HttpErrors.NOT_FOUND) {
        setError("verificationCode", { type: "", message: "Incorrect code" })
        setState({ ...state, sending: false })
      } else {
        setState({ ...state, isInError: true, sending: false })
      }
    }
  })

  const backRoute = props.requestCardPath + "/phone-number"

  const formattedNumber = phoneNumber ? `+${PhoneCodes[countryCode]} ${phoneNumber}` : "your number"

  return (
    <MasterLayout header={<RequestCardHeader backRoute={backRoute} />}>
      <EmployeeOnlySpaceContainer>
        <BodyWithRightSidebarLayout>
          <RequestCardWizardHeader step={2}>{l`carrotCard.request.confirmPhoneNumber`}</RequestCardWizardHeader>
          <WizardWrapper
            back
            done
            backRoute={backRoute}
            doneText={l`next`}
            nextId="request-card-verify-phone-number-next-button"
            onDone={onSubmit}
            nextDisabled={!formState.isValid && !formState.isDirty}
            sending={state.sending}
          >
            {state.isInError ? (
              <ErrorMessageMarkdown align="tl" source={l`carrotCard.request.error`} />
            ) : (
              <Body color="black-80">
                {l`carrotCard.request.enterTheCode`}
                {formattedNumber}.
              </Body>
            )}
            <Spacer height={1.5} />
            <CompleteFormInput
              label={l`carrotCard.request.enterCode`}
              placeholder="000000"
              errors={errors}
              {...register("verificationCode", {
                pattern: {
                  value: /\d{6}/,
                  message: l`Incorrect code`
                }
              })}
            />
            <div className="flex flex-row justify-end">
              {state.isResendLinkVisible ? (
                <TextLink to="#" onClick={handleResendClick} style={{ paddingBottom: "5px" }}>
                  {l`carrotCard.request.resendCode`}
                </TextLink>
              ) : (
                <Body color="black-60">
                  {l`carrotCard.request.codeSentTo`}
                  {phoneNumber}
                </Body>
              )}
            </div>
            <Spacer height={1} />
          </WizardWrapper>
          <Spacer height={1.5} />
          <HR color="black-20" />
        </BodyWithRightSidebarLayout>
      </EmployeeOnlySpaceContainer>
    </MasterLayout>
  )
}

export { VerifyPhoneNumber }
